export default __webpack_public_path__ + "static/media/whatsapp.a0eb2e56.png";